export class Address {
  id: number;
  street: string;
  care_of_id: number;
  attention: string;
  building: string;
  suite: string;
  floor: string;
  po_box: string;
  city: string;
  state: string;
  postal_code: string;
  country: string;
  county: string;
  is_on_mailing_list: boolean = false;
  position: number;
  township: string;
  contact_id: number;
  created_at: any;
  updated_at: any;
  created_by: any;
  updated_by: any;
  version: number;
  province: string;
  identity_code: string;
  color_code: string;
  editing: boolean = false;
  deleting: boolean = false;
  address_display: string;
  type_names: Array<string> = [];
  address_type_ids: Array<number> = [];
  address_clipboard: any;
}
